import React, { useState } from "react";
import createInstance from "../../../api/axiosinstance";
import { toast } from "react-toastify";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEye, faEyeSlash } from "@fortawesome/free-solid-svg-icons";

const InterviewerJoining = () => {
  const aiDishaApi = createInstance("DISHA");
  const [loading, setLoading] = useState(false);

  const [showPassword, setShowPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);

  const [formData, setFormData] = useState({
    name: "",
    email: "",
    mobile: "",
    Date_of_birth: "",
    address: { H_No: "", city: "", state: "", country: "" },
    password: "",
    confirm_password: "",
    role: "TP-Interviewer",
    status: "InActive",
    activation_status: "Pending",
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    if (["H_No", "city", "state", "country"].includes(name)) {
      setFormData({
        ...formData,
        address: { ...formData.address, [name]: value },
      });
    } else {
      setFormData({ ...formData, [name]: value });
    }
  };

  const validateForm = () => {
    const emailRegex = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,6}$/;
    const phoneRegex = /^[0-9]{10}$/;

    if (!formData.name.trim()) return "Name is required";
    if (!formData.email || !emailRegex.test(formData.email))
      return "Enter a valid email";
    if (!formData.mobile || !phoneRegex.test(formData.mobile))
      return "Enter a valid 10-digit mobile number";
    if (!formData.Date_of_birth) return "Date of birth is required";
    if (!formData.address.H_No.trim()) return "House No. is required";
    if (!formData.address.city.trim()) return "City is required";
    if (!formData.address.state.trim()) return "State is required";
    if (!formData.address.country.trim()) return "Country is required";
    if (!formData.password) return "Password is required";
    if (formData.password.length < 6)
      return "Password must be at least 6 characters";
    if (formData.password !== formData.confirm_password)
      return "Passwords do not match";

    return null;
  };

  const clearForm = () => {
    setFormData({
      name: "",
      email: "",
      mobile: "",
      Date_of_birth: "",
      address: { H_No: "", city: "", state: "", country: "" },
      password: "",
      confirm_password: "",
      role: "TP-Interviewer",
      status: "InActive",
      activation_status: "Pending",
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const validationError = validateForm();
    if (validationError) {
      toast.error(validationError);
      return;
    }

    try {
      setLoading(true);
      const response = await aiDishaApi.post("/interviewer_register", formData);
      toast.success(response.data.message || "Registration successful!");
      clearForm();
    } catch (error) {
      console.error(error);
      toast.error(
        error.response?.data?.detail || "Error while registering interviewer"
      );
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="container mt-4" style={{ maxWidth: "700px" }}>
      <div
        className="card"
        style={{ backgroundColor: "white", borderRadius: "8px" }}
      >
        <div
          className="card-header"
          style={{
            backgroundColor: "#033538",
            color: "white",
            borderRadius: "8px 8px 0 0",
          }}
        >
          <h5 className="mb-0" style={{ fontFamily: "poppins" }}>
            Interviewer Registration
          </h5>
        </div>

        <form onSubmit={handleSubmit}>
          <div className="card-body">
            {/* Password */}
            <div className="row">
              <div className="col-md-6 mb-3 position-relative">
                <label className="form-label" style={{ color: "#033538" }}>
                  Password *
                </label>
                <div className="input-group">
                  <input
                    type={showPassword ? "text" : "password"}
                    className="form-control form-control-sm"
                    name="password"
                    value={formData.password}
                    onChange={handleChange}
                    required
                  />
                  <span
                    className="input-group-text"
                    style={{
                      cursor: "pointer",
                      backgroundColor: "white",
                      borderLeft: "none",
                    }}
                    onClick={() => setShowPassword(!showPassword)}
                  >
                    <FontAwesomeIcon
                      icon={showPassword ? faEyeSlash : faEye}
                      color="#033538"
                    />
                  </span>
                </div>
              </div>

              {/* Confirm Password */}
              <div className="col-md-6 mb-3 position-relative">
                <label className="form-label" style={{ color: "#033538" }}>
                  Confirm Password *
                </label>
                <div className="input-group">
                  <input
                    type={showConfirmPassword ? "text" : "password"}
                    className="form-control form-control-sm"
                    name="confirm_password"
                    value={formData.confirm_password}
                    onChange={handleChange}
                    required
                  />
                  <span
                    className="input-group-text"
                    style={{
                      cursor: "pointer",
                      backgroundColor: "white",
                      borderLeft: "none",
                    }}
                    onClick={() => setShowConfirmPassword(!showConfirmPassword)}
                  >
                    <FontAwesomeIcon
                      icon={showConfirmPassword ? faEyeSlash : faEye}
                      color="#033538"
                    />
                  </span>
                </div>
              </div>
            </div>
          </div>

          <div className="card-footer d-flex justify-content-end border-0">
            <button
              type="button"
              className="btn btn-outline-secondary btn-sm me-2"
              onClick={clearForm}
            >
              Clear
            </button>
            <button
              type="submit"
              className="btn btn-sm"
              style={{ backgroundColor: "#033538", color: "white" }}
              disabled={loading}
            >
              {loading ? "Registering..." : "Submit"}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default InterviewerJoining;
